<template>
  <div class="pi-stagebars">
    <ul class="pi-stagebars__list">
      <li v-for="row in rows" :key="row.key" class="pi-stagebars__row">
        <span class="pi-stagebars__label">{{ row.label }}</span>
        <div v-if="!row.empty" class="pi-stagebars__track" role="group" :aria-label="'Onde as empresas param até D+' + row.window">
          <button v-for="segment in visible(row)" :key="segment.key" type="button" class="pi-stagebars__segment"
                  :class="{ 'is-on': isOn(segment) }" :style="segmentStyle(segment)" :title="segment.title"
                  :aria-label="segment.ariaLabel" :aria-pressed="isOn(segment) ? 'true' : 'false'"
                  @click="$emit('select', { window: segment.window, stage: segment.stage })">
            <span v-if="segment.showText" class="pi-stagebars__text">{{ segment.shareText }}</span>
          </button>
        </div>
        <span v-else class="pi-stagebars__empty">Nenhuma empresa com a janela fechada.</span>
        <span class="pi-stagebars__total">{{ row.eligibleText }}</span>
      </li>
    </ul>
    <ul class="pi-stagebars__legend" aria-label="Legenda das etapas">
      <li v-for="stage in legend" :key="stage.stage" class="pi-stagebars__legend-item" :title="stage.text">
        <span class="pi-stagebars__swatch" :style="{ background: stage.background }" aria-hidden="true"></span>{{ stage.stage }} · {{ stage.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { ONBOARDING_STAGES, STAGE_COLORS } from "./piOnboardingModel.js";

export default {
  name: "pi-stage-bars",
  props: {
    rows: { type: Array, default: () => [] },
    selected: { type: Object, default: null },
  },
  computed: {
    legend() {
      return ONBOARDING_STAGES.map((stage) => Object.assign({ background: STAGE_COLORS[stage.stage] }, stage));
    },
  },
  methods: {
    visible(row) {
      return row.segments.filter((segment) => segment.widthPct > 0);
    },
    isOn(segment) {
      return !!this.selected && this.selected.window === segment.window && this.selected.stage === segment.stage;
    },
    segmentStyle(segment) {
      return { width: segment.widthPct + "%", background: segment.background, color: segment.color };
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-stagebars__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pi-stagebars__row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.pi-stagebars__label {
  flex: 0 0 36px;
  font-size: 12px;
  font-weight: 700;
  color: #3a424e;
}

.pi-stagebars__track {
  display: flex;
  flex: 1 1 auto;
  height: 26px;
  overflow: hidden;
  border-radius: 4px;
  background: #f3f4f6;
}

.pi-stagebars__segment {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 3px;
  height: 100%;
  padding: 0;
  border: 0;
  border-right: 1px solid #ffffff;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.pi-stagebars__segment:last-child {
  border-right: 0;
}

.pi-stagebars__segment:hover,
.pi-stagebars__segment:focus {
  outline: 2px solid #1d12b9;
  outline-offset: -2px;
}

.pi-stagebars__segment.is-on {
  outline: 3px solid #1d12b9;
  outline-offset: -3px;
}

.pi-stagebars__text {
  overflow: hidden;
  white-space: nowrap;
}

.pi-stagebars__empty {
  flex: 1 1 auto;
  font-size: 12px;
  color: #6b7280;
}

.pi-stagebars__total {
  flex: 0 0 auto;
  min-width: 90px;
  font-size: 12px;
  color: #4e5560;
  text-align: right;
}

.pi-stagebars__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
  font-size: 11px;
  color: #4e5560;
}

.pi-stagebars__legend-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pi-stagebars__swatch {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #d1d5db;
  border-radius: 2px;
}

@media (max-width: 767px) {
  .pi-stagebars__total {
    min-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piStageBars.vue